import { defineStore } from "pinia";
import { ref } from "vue";
import { makeMenu } from "@/routes";
import Config from "@/config";

export const useMenuStore = defineStore('menu', () => {
    const user = Config.getUser();
    const menu = ref(makeMenu(user));

    function setMenu(newMenu) {
        menu.value = newMenu;
    }

    return { menu, setMenu };
});
